import React from 'react';
import PropTypes from 'prop-types';
import CheckBox from 'common/components/elements/inputs/checkbox-label';
import Input from "common/components/elements/inputs/inputs";
import Filter from 'common/components/responsive/filter';
import cx from 'classnames'

const LockedInputs = ({
   access,
   hasCanceldPercentag,
   inputName,
   onChange,
   isPriceError,
   maxPrice,
   onWrongPriceLength,
   priceValidation,
   onFocus,
   contentType,
   minPrice,
}) => {

   const calcPercentage = (percentage) => {
      const unlockPrice = +access.unlock_price
      let price = (unlockPrice + (unlockPrice * percentage / 100));
      price = price.toFixed(2);
      return `${ percentage }% (${ price } USD)`
   }
   const getOptions = () => {
      let res = []
      for(let index = 10; index < 100; index = index + 5) {
         const item = { name: calcPercentage(index), value: index };
         res.push(item)
      }
      return res
   }

   return (
      <div
         role='presentation'
         onClick={ e => e.stopPropagation() }
         className={
            cx({
               'flex flex-col mt-4 ml-9': true,
            })
         }
      >
         <div className='w-full cursor-auto'>
            <Input
               rightText='USD'
               value={ access.unlock_price }
               name={ `unlock_price_${ inputName }` }
               type={ 'number' }
               onChange={ (name, value) => {
                  let price = !value ? value : +value
                  onChange('unlock_price', price);
               } }
               // autoComplete='off'
               errorMessage={ isPriceError && priceValidation(access.unlock_price) ? `Price must be between ${ contentType === 'store' ? minPrice : '0.25' } USD and ${ maxPrice } USD` : null }
               onInputFocus={ onFocus }
               height='10'
               isPriceInput
               maxPrice={ maxPrice }
            />
         </div>
         {
            hasCanceldPercentag && (
               <>
                  <div className='flex items-center mt-3'>
                     <div className='flex w-full'>
                        <CheckBox
                           label={ `Cancelled pay ${ access.cancelled_pay_more_to_unlock_percentage }% more ` }
                           name={ `cancelled_pay_more_to_unlock_${ inputName }` }
                           checked={ access.cancelled_pay_more_to_unlock }
                           onChange={ (name, value) => onChange('cancelled_pay_more_to_unlock', !access.cancelled_pay_more_to_unlock) }
                           textColor='secondary'
                           disabled={ false }
                           padding='0'
                           className='w-full'
                           margin='2'
                        />
                     </div>

                  </div>
                  {
                     access.cancelled_pay_more_to_unlock && (
                        <div className='mt-3 !w-[fit-content] cancelled-pay-more-select'>
                           {/* <Select
                              options={ getOptions() }
                              placeholder='Select'
                              activeValue={ access.cancelled_pay_more_to_unlock_percentage }
                              className='z-40 text-sm'
                              onSelectionchange={ (value) => onChange('cancelled_pay_more_to_unlock_percentage', value) }
                           /> */}
                           <Filter
                              name={ access.cancelled_pay_more_to_unlock_percentage ? calcPercentage(access.cancelled_pay_more_to_unlock_percentage) : 'Select' }
                              type='filter'
                              data={ getOptions() }
                              activeSelectedValue={ { value: access.cancelled_pay_more_to_unlock_percentage  } }
                              desktopType='desktop'
                              className='percentage-select !px-4 !py-2'
                              height='9'
                              onFilterChange={ (value, name) => onChange('cancelled_pay_more_to_unlock_percentage', value) }
                              onClickClear={ () => {
                                 // onClearFilter(true, 'status')
                              } }
                              isAutoSave
                              contentStyles={ {
                                 left: 0,
                                 top: '-204px',
                                 maxHeight: '200px',
                                 width: '100%',
                              } }
                              viewClassName='!w-[fit-content]'
                              radioClassName='!px-4'
                              rotateIconOnOpenContent
                              notShowTooltip
                              notTruncate
                           />
                        </div>
                     )
                  }
               </>
            )
         }
      </div>
   )
}

LockedInputs.propTypes = {
   onChange: PropTypes.func,
   inputName: PropTypes.any,
   hasCanceldPercentag: PropTypes.bool,
   access: PropTypes.object,
   maxPrice: PropTypes.number,
   isPriceError: PropTypes.bool,
   onWrongPriceLength: PropTypes.func,
   priceValidation: PropTypes.func,
   onFocus: PropTypes.func,
   contentType: PropTypes.string,
   minPrice: PropTypes.number,
}

export default LockedInputs
